import { Injectable } from '@angular/core';
import {Title} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";
import {Globals} from "./Globals";

@Injectable({
  providedIn: 'root'
})
export class TitleService {

  private _title: string = null;
  private _defaultTitles: string[] = [Globals.APP_NAME];
  private _titles: string[] = this._defaultTitles;

  constructor(private browserTitle: Title,
              private trans: TranslateService) {
  }

  async newTitle(title: string|string[] = null, translate: boolean|Object = false) {
    // Copy, don't alias: the translate branch below pushes onto this._titles, and
    // aliasing it to _defaultTitles would permanently grow that array (R1: title
    // accumulates across navigations, e.g. "Teamer › Hours › Km").
    this._titles = [...this._defaultTitles];
    if(translate && title){
      let to = translate instanceof Object ? translate : undefined;
      // A copy: pushing onto _defaultTitles would keep every translated title on later pages.
      this._titles = [...this._defaultTitles, await this.trans.get(title, to).toPromise()];
    }
    else if(title && title !== Globals.APP_NAME){
      this._titles = this._titles.concat(title);
    }

    this._title = this._titles.join(' › ');
    this.browserTitle.setTitle(this._title);
  }

  get titles(){
    return this._titles;
  }

  get title(){
    return this._title;
  }
}
